import styled, { css } from 'styled-components';

const FoodButtonWrapper = styled.div(
  ({ theme, needsToAddItems }) =>
    needsToAddItems &&
    css`
      position: fixed;
      bottom: 0;
      right: 0;
      left: 0;
      z-index: ${theme.cart.foodButton.zIndex + 1};
      padding: ${theme.spacing(10, 12)};
      background-color: ${theme.cart.foodButton.background};
    `,
);

export default FoodButtonWrapper;
